import React from 'react';
import { Button, Dialog, DialogContent, DialogTitle, DialogActions } from '@material-ui/core';
import BookingItemPartialRefund from '../../pages/bookingitemedit/components/BookingItemPartialRefund';

function BookingEditRefundModal({
    bookingUserId,
    transactionSum,
    onReload,
    bookingItemId,
    showModal,
    MODAL_TYPE
}) {
    return (
        <Dialog
            aria-labelledby="calendar-event-info-modal"
            maxWidth="sm"
            open
            onClose={() => showModal(MODAL_TYPE.NONE)}
        >
            <DialogTitle>Refund</DialogTitle>
            <DialogContent>
                <BookingItemPartialRefund
                    bookingUserId={bookingUserId}
                    maxAmount={transactionSum}
                    onSuccess={() => {
                        // Close the modal
                        showModal(MODAL_TYPE.NONE);
                        // Trigger reload in parent
                        if (onReload) {
                            onReload();
                        }
                    }}
                    bookingItemId={bookingItemId}
                />
            </DialogContent>
            <DialogActions>
                <Button variant="text" onClick={() => showModal(MODAL_TYPE.NONE)}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default BookingEditRefundModal;
